export default "__VITE_ASSET__PDlQ4ew3__"